<div class="square-banner-logo container" fxLayoutAlign="center center"
     [ngClass]="{future: store.isFuture(), historical: store.isHistorical()}">
  <img [alt]="'SQUARE_BANNER_LOGO.ALT' | translate" [src]="bannerImageUrl"/>
</div>
